import { useCallback, useState } from "react";

const useModal = (isModalShown = false) => {
  const [isModalVisible, setIsModalVisible] = useState(isModalShown);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  return {
    isModalVisible,
    setIsModalVisible,
    showModal,
    closeModal,
  };
};

export default useModal;
